(function (){
    'use strict';

    angular
        .module('services')
        .service('StudyAdService', StudyAdService);

    StudyAdService.$inject = ['$http', 'API_BASE'];

    function StudyAdService ($http, API_BASE) {
        var service = this;

        service.getEvents = getEvents;
        service.getUsers = getUsers;

        function getEvents() {
            return $http.get(API_BASE + '/studyad/list');
        }

        function getUsers(query)
        {
            return $http.get(API_BASE + '/studyad/users/list', {params : query});
        }
    }
})();